module.exports = __webpack_public_path__ + "img/error.dd798303.svg";